import React, { Component } from 'react'
import { Container, Row, Col } from 'styled-bootstrap-grid'
import styled from 'styled-components'

import Internal from './Internal'
import External from './External'
import Download from './Download'

const Wrapper = styled.div`
  margin-bottom: 40px;
`

export default class LinkBoxes extends Component {
  render() {
    const { boxes } = this.props

    return (
      <Wrapper>
        <Container fluid>
          {boxes.map((box, index) => {
            switch (box.linkType) {
              case 'internal':
                return (
                  <Row key={index}>
                    <Col
                      sm={7}
                      smOffset={1}
                      lgOffset={2}
                      xl={5}
                    >
                      <Internal {...box} />
                    </Col>
                  </Row>
                )
              case 'external':
                return (
                  <Row key={index}>
                    <Col
                      sm={7}
                      smOffset={1}
                      lgOffset={2}
                      xl={5}
                    >
                      <External {...box} />
                    </Col>
                  </Row>
                )
              case 'download':
                return (
                  <Row key={index}>
                    <Col
                      sm={7}
                      smOffset={1}
                      lgOffset={2}
                      xl={5}
                    >
                      <Download {...box} />
                    </Col>
                  </Row>
                )
            
              default:
                return null
            }
          })}
        </Container>
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/modules/LinkBoxes/index.js